export const registry = {
  title: 'Container Registry',
  subtitle: 'OCI-kompatible Container-Image-Registry',
  storageLocation: 'Speicherort',
  storageLocationValue: 'Nürnberg, Deutschland',

  tabs: {
    overview: 'Übersicht',
    tokens: 'Zugriffs-Token',
    cleanup: 'Bereinigungsregeln'
  },

  notEnabled: {
    title: 'Container Registry',
    description: 'Pushe und pulle Container-Images mit einer privaten OCI-Registry. 1 GB kostenloser Speicher inklusive, danach {price}/GB/Monat.',
    button: 'Registry aktivieren'
  },

  enable: {
    title: 'Container Registry aktivieren',
    slug: 'Registry-Namespace',
    slugHint: 'Wird in Image-Pfaden verwendet: registry.itsh.dev/<slug>/image:tag',
    slugPlaceholder: 'meine-firma',
    confirm: 'Bestätigen',
    previewLabel: 'Vorschau des Image-Pfads',
    button: 'Aktivieren',
    slugRequired: 'Bitte zuerst einen Namespace festlegen',
    slugTaken: 'Dieser Namespace ist bereits vergeben',
    slugLocked: 'Der Namespace kann nicht mehr geändert werden, weil bereits Images darunter gespeichert sind',
    alreadyEnabled: 'Für diesen Account ist bereits eine Container Registry aktiv',
    pricingTitle: 'Preise',
    pricingFreeStorage: '1 GB Speicher inklusive',
    pricingStorage: 'Speicher ab 1 GB',
    pricingStorageRate: '{price} / GB / Monat',
    pricingEgress: 'Egress',
    pricingEgressRate: '{price} / GB'
  },

  loadError: {
    title: 'Registry konnte nicht geladen werden',
    description: 'Die Registry-Daten konnten nicht gelesen werden. Bitte versuche es erneut.',
    retry: 'Erneut versuchen'
  },

  overview: {
    status: 'Status',
    created: 'Erstellt',
    slug: 'Namespace',
    storage: 'Speicher',
    freeTier: 'kostenlos',
    of: 'von',
    statuses: {
      active: 'Aktiv',
      suspended: 'Gesperrt',
      deactivated: 'Deaktiviert',
      quota_exceeded: 'Speicher voll'
    },
    quotaExceededHint:
      'Dein kostenloses Speicherkontingent ist aufgebraucht. Neue Pushes sind gesperrt, Pulls laufen weiter. Lösche Images, um wieder unter das Limit zu kommen.',
    quickstart: 'Schnellstart',
    loginCommand: 'Anmelden',
    loginHint: 'Benutzername: {slug} — Passwort: ein Registry-Token',
    pushCommand: 'Image pushen',
    copied: 'Kopiert!',
    disable: 'Registry deaktivieren',
    disableConfirm: 'Bist du sicher, dass du die Container-Registry deaktivieren möchtest? Deine Images bleiben im Speicher, sind aber nicht mehr erreichbar.'
  },

  repos: {
    title: 'Repositories',
    empty: 'Noch keine Repositories',
    emptyHint: 'Pushe dein erstes Image, um loszulegen',
    columns: {
      name: 'Repository',
      actions: 'Aktionen'
    },
    viewTags: 'Tags anzeigen',
    delete: {
      title: 'Repository löschen',
      message: 'Bist du sicher, dass du das Repository „{repo}" und alle zugehörigen Images löschen möchtest? Dies kann nicht rückgängig gemacht werden.'
    }
  },

  tags: {
    title: 'Tags',
    empty: 'Keine Tags',
    columns: {
      tag: 'Tag',
      lastUpdated: 'Zuletzt aktualisiert',
      actions: 'Aktionen'
    },
    delete: {
      title: 'Tag löschen',
      message: 'Bist du sicher, dass du den Tag „{tag}" löschen möchtest? Dies kann nicht rückgängig gemacht werden.'
    },
    back: 'Zurück zu Repositories'
  },

  tokens: {
    title: 'Zugriffs-Token',
    empty: 'Noch keine Zugriffs-Token',
    emptyHint: 'Erstelle einen Token zur Authentifizierung an der Registry',
    columns: {
      name: 'Name',
      scopes: 'Berechtigungen',
      created: 'Erstellt',
      lastUsed: 'Zuletzt verwendet',
      expires: 'Ablauf',
      actions: 'Aktionen'
    },
    allRepos: 'Alle Repositories',
    never: 'Nie',
    noExpiry: 'Kein Ablauf',
    pullOnly: 'Nur Pull',
    create: {
      title: 'Zugriffs-Token erstellen',
      subtitle: 'Token zur Docker/OCI-Registry-Authentifizierung generieren',
      name: 'Token-Name',
      namePlaceholder: 'ci-pipeline',
      scopes: 'Repository-Bereich',
      scopesHint:
        'Repository-Namen mit Komma getrennt, z. B. my-app. Der Token erreicht dann nur diese Repositories und die darunter verschachtelten. Leer lassen für Zugriff auf alle Repositories.',
      invalidScope: 'Gib Repository-Namen unter deinem Namespace an, etwa my-app oder team/api: Kleinbuchstaben, Ziffern und . _ - als Trenner.',
      expiry: 'Ablauf',
      noExpiry: 'Kein Ablauf',
      pullOnlyHint: 'Für Cluster und Deploy-Ziele. Push und Löschen werden abgelehnt. Lässt sich später nicht ändern.',
      button: 'Token erstellen'
    },
    secret: {
      title: 'Zugriffs-Token erstellt',
      warning: 'Speichere diesen Token jetzt. Er wird nicht erneut angezeigt.',
      token: 'Zugriffs-Token',
      copied: 'Kopiert!',
      tabs: {
        docker: 'Docker',
        podman: 'Podman',
        ci: 'CI/CD'
      }
    },
    delete: {
      title: 'Token löschen',
      message: 'Bist du sicher, dass du den Token „{name}" löschen möchtest? CI/CD-Pipelines, die diesen Token verwenden, funktionieren nicht mehr.'
    }
  },

  cleanup: {
    title: 'Bereinigungsregeln',
    empty: 'Keine Bereinigungsregeln konfiguriert',
    emptyHint: 'Füge Regeln hinzu, um alte Images automatisch zu bereinigen und Speicherkosten zu sparen',
    columns: {
      repository: 'Repository',
      rule: 'Regel',
      value: 'Wert',
      patterns: 'Muster',
      on: 'An',
      off: 'Aus',
      enabled: 'Aktiv',
      actions: 'Aktionen'
    },
    ruleTypes: {
      keep_last: 'Letzte N Tags behalten',
      untagged_ttl: 'Ungetaggte nach N Tagen löschen',
      tag_ttl: 'Tags nach N Tagen löschen'
    },
    allRepos: 'Alle Repositories',
    create: {
      title: 'Bereinigungsregel erstellen',
      repository: 'Repository',
      repositoryHint: 'Verwende * für alle Repositories oder wähle eines aus der Liste. Ein eingetippter Name gilt relativ zu deinem Namespace',
      ruleType: 'Regeltyp',
      value: 'Wert',
      valueHint: {
        keep_last: '1 bis 1000 Tags',
        days: '1 bis 3650 Tage'
      },
      keepPatterns: 'Behalten-Muster',
      keepPatternsHint: 'Kommagetrennte Glob-Muster, die immer behalten werden (z.B. v*,latest,main)',
      deletePatterns: 'Löschen-Muster',
      deletePatternsHint: 'Kommagetrennte Glob-Muster, die gelöscht werden (z.B. pr-*,sha-*)',
      button: 'Regel erstellen'
    },
    delete: {
      title: 'Regel löschen',
      message: 'Bist du sicher, dass du diese Bereinigungsregel löschen möchtest?'
    }
  },

  usage: {
    title: 'Nutzung',
    storage: 'Speicher',
    egress: 'Egress',
    pulls: 'Pulls',
    pushes: 'Pushes',
    covered: 'durch Freibetrag abgedeckt',
    billable: 'kostenpflichtig',
    pricingHint: 'Speicher: {storagePrice}/GB/Monat · Egress: {egressPrice}/GB · {freeStorage} Speicher + {freeEgress} Egress frei'
  },

  notifications: {
    enabled: 'Container-Registry aktiviert',
    disabled: 'Container-Registry deaktiviert',
    tokenCreated: 'Zugriffs-Token erstellt',
    tokenDeleted: 'Zugriffs-Token gelöscht',
    tagDeleted: 'Tag gelöscht',
    repoDeleted: 'Repository gelöscht',
    ruleCreated: 'Bereinigungsregel erstellt',
    ruleDeleted: 'Bereinigungsregel gelöscht',
    slugSet: 'Registry-Namespace festgelegt'
  }
} as const
